import { IControl, Map } from "mapbox-gl";

export class MapBoxMapLockControl implements IControl {
  private _container: HTMLElement;
  private _map: Map;
  private _isLocked: boolean;
  private _callback: () => void;

  public get isLocked(): boolean {
    return this._isLocked;
  }

  constructor(isLocked: boolean, callback: () => void) {
    this._isLocked = isLocked;
    this._callback = callback;
  }

  public setLockState(isLocked: boolean, emitEvent: boolean = true): void {
    if (this._isLocked === isLocked) {
      return;
    }
    this._isLocked = isLocked;
    if (emitEvent) {
      this._callback();
    }
    this._container.querySelector('button')?.classList.toggle('icon-locked', this._isLocked);
    this._container.querySelector('button')?.classList.toggle('icon-unlocked', !this._isLocked);
  }

  onAdd(map: Map): HTMLElement {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this._container.innerHTML = `
      <button id="lockButton" class="mapboxgl-ctrl-icon maps-icon ${this._isLocked ? 'icon-locked' : 'icon-unlocked'}" type="button" title="Toggle Lock"></button>
    `;

    this._container.querySelector('button')?.addEventListener('click', () => {
      this._isLocked = !this._isLocked;
      this._container.querySelector('button')?.classList.toggle('icon-locked', this._isLocked);
      this._container.querySelector('button')?.classList.toggle('icon-unlocked', !this._isLocked);
      this._callback();
    });

    return this._container;
  }

  onRemove(): void {
    this._container.parentNode?.removeChild(this._container);
    this._map = undefined!;
  }
}
